import { render } from "./TakEawayicecream.vue?vue&type=template&id=4817d63a"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/TakEawayicecream.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4817d63a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4817d63a', __exports__)) {
    api.reload('4817d63a', __exports__)
  }
  
  module.hot.accept("./TakEawayicecream.vue?vue&type=template&id=4817d63a", () => {
    api.rerender('4817d63a', render)
  })

}


export default __exports__